import React from 'react';
import { useReveal } from '../lib/useReveal';
export function SolutionSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#1e1e30] py-14 md:py-20 px-4 border-t border-white/5" data-id="element-496">
      <div className="container mx-auto max-w-3xl" data-id="element-497">
        <div ref={ref1} className={`reveal text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-498">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-5 leading-tight text-white" data-id="element-499">
            El Reiki es una práctica energética
            <br data-id="element-500" />
            utilizada en todo el mundo
            <br data-id="element-501" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4a017] via-[#f0c040] to-[#d4a017]" data-id="element-502">
              para armonizar cuerpo, mente y energía.
            </span>
          </h2>

          <div className="text-lg md:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto" style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontWeight: 500
        }} data-id="element-503">
            <p data-id="element-504">
              Aprender Reiki te permite canalizar energía,
              <br data-id="element-505" />
              equilibrar tu propio campo energético
              <br data-id="element-506" />y ayudar a otras personas a sanar.
            </p>
          </div>
        </div>
      </div>
    </section>;
}